import {Component} from "@angular/core";

@Component({
  selector: "app-payout-history",
  templateUrl: "./payout-history.component.html",
  styleUrls: ["./payout-history.component.scss"],
})
export class PayoutHistoryComponent {}
